import http from '../config/http';
import routes from '../config/api_routes';

export const all = (props = {}) => {
    props.paged = true;
    return http().get(routes.girocard.all, {
        params: props
    });
}

export const myCards = () => http().get(routes.girocard.myCards);

export const getById = (id, props = {}) => {
    var route = (routes.girocard.byId||'').replace(':id', id);
    
    return http().get(route, {
        params: props
    });
}

export const save = data => http().post(routes.girocard.all, data)

export const block = value => http().put(`${routes.girocard.blockCard}${value}`)

export const blockWithCredit = (id, saldoBloqueio) => {
    const data = new FormData()
    data.append("Id", id);
    data.append("saldoBloqueio", saldoBloqueio.toFixed(2));
    return http().put(`${routes.girocard.blockCardCredit}`, data);
};

export const removeImage = (partnerId, imageId) => {
    const url = (routes.girocard.deleteImage||'').replace(':id', partnerId); 
    return http().delete(url, {
                params: {
                    imageId
                }
            });
    
}
export const remove = id => {
    var route = (routes.girocard.byId||'').replace(':id', id);
    return http().delete(route);
}

export const pegaUltimoCartaoGiro = () => {
    return new Promise((res, rej) => {
        myCards().then(({data}) => {
            let cards = data.sort((a, b) => b.id - a.id);
            res(cards.length ? cards[0] : null);
        }).catch(rej);
    });
}